import JSONModel from "sap/ui/model/json/JSONModel";
import BaseController from "./BaseController";
import AuthenticationService from "../util/AuthenticationService";
import { confirmSignIn } from "aws-amplify/auth";

/**
 * @namespace com.reply.leaviosa.controller
 */
export default abstract class Login extends BaseController {

    public onInit(): void {

        // Create a new JSON model for the view
        const viewModel = new JSONModel({
            email: undefined,
            password: undefined,
            confirmSignInInput: undefined,
            confirmSignIn: false
        });

        // Set the view model for the view
        this.getView().setModel(viewModel);

    }

    //*************************************************************************************
    // EVENT HANDLERS
    //*************************************************************************************

    public async onLogin(): Promise<void> {
        const viewModel = this.getView().getModel() as JSONModel;
        const username = viewModel.getProperty("/email");
        const password = viewModel.getProperty("/password");
        if (viewModel.getProperty("/confirmSignIn")) {
            const newPw = viewModel.getProperty("/confirmSignInInput");
            const isSignedIn = await AuthenticationService.confirmSignIn(newPw);
            if (isSignedIn) {
                this.navTo("home");
                viewModel.setProperty("/email", undefined);
                viewModel.setProperty("/password", undefined);
                viewModel.setProperty("/confirmSignIn", false);
                viewModel.setProperty("/confirmSignInInput", undefined);
            }
        } else {
            const { loggedIn, nextStep } = await AuthenticationService.login(username, password);

            if (nextStep === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED") {
                viewModel.setProperty("/confirmSignIn", true);
                return;
            }

            if (loggedIn) {
                this.navTo("home");
                viewModel.setProperty("/email", undefined);
                viewModel.setProperty("/password", undefined);
            }
        }
    }

    public async onNavigatePwForget(): Promise<void> {
        this.navTo("forgotPassword");
    }

    public async onMicrosoftEntraIdLogin(): Promise<void> {
        AuthenticationService.loginWithRedirect();
    }
}